/* ============================================================
   Victoria's Gala — Inject sale badge over product card images
   Reads data-vg-discount from price snippet output.
   ============================================================ */
(function () {
  'use strict';

  function injectBadgesOnCards() {
    // Find all price containers marked as on-sale by our patched price.liquid
    var saleContainers = document.querySelectorAll('[data-vg-on-sale="true"]');

    saleContainers.forEach(function (priceEl) {
      var pct = priceEl.getAttribute('data-vg-discount');
      if (!pct || pct === '0') return;

      // Find the closest card wrapper (excluding PDP)
      var card = priceEl.closest('.vg-feat-card, .vg-best-card, .product-card, [class*="product-card"]');
      if (!card) return;

      // Find the image/media area inside the card
      var media = card.querySelector('.vg-feat-card__media, .vg-best-card__media, [class*="__media"], .card__media, .media');
      var target = media || card;

      // Avoid duplicates
      if (target.querySelector('.vg-card-sale-badge')) return;

      // Ensure target is positioned
      var computed = window.getComputedStyle(target);
      if (computed.position === 'static') {
        target.style.position = 'relative';
      }

      var badge = document.createElement('span');
      badge.className = 'vg-card-sale-badge';
      badge.textContent = '-' + pct + '%';
      badge.setAttribute('aria-hidden', 'true');
      target.appendChild(badge);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectBadgesOnCards);
  } else {
    injectBadgesOnCards();
  }

  // Re-run on dynamic updates (collection filters, infinite scroll, AJAX)
  var observer = new MutationObserver(function (mutations) {
    var needsRescan = false;
    mutations.forEach(function (m) {
      if (m.addedNodes && m.addedNodes.length > 0) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1 && (n.matches && (n.matches('[data-vg-on-sale]') || n.querySelector && n.querySelector('[data-vg-on-sale]')))) {
            needsRescan = true;
          }
        });
      }
    });
    if (needsRescan) {
      requestAnimationFrame(injectBadgesOnCards);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
